/* eslint-disable camelcase */
import React, {
  useEffect,
  useCallback,
} from 'react';
import {
  useParams,
  useNavigate,
} from 'react-router-dom';
import {
  getStatus,
} from 'redux-resource';
import {
  shallowEqual,
  useDispatch,
  useSelector,
} from 'react-redux';

import {
  coreActions,
  coreSelectors,
} from '@gymcloud/core';

import {
  Spinner,
  NotFound,
} from 'web-components';

import * as S from '../styled';

const RedirectToDocument = () => {
  const params = useParams();
  const navigate = useNavigate();
  const id = Number(params.id);

  if (!id) {
    navigate('/welcome');
  }

  const dispatch = useDispatch();

  useEffect(() => {
    if (id) {
      dispatch(
        coreActions.requestGetDocument({
          id,
          withAssignees: false,
        }),
      );
    }
  }, [id]);

  const mapState = useCallback(state => ({
    readStatus: getStatus(
      state,
      [
        'documents.requests.fetchDocument.status',
        `documents.meta[${id}].readStatus`,
      ],
      true,
    ),
    document: coreSelectors.getResourceById(
      'documents',
      id,
    )(state),
  }), [id]);

  const {
    document,
    readStatus,
  } = useSelector(mapState, shallowEqual);

  if (readStatus.succeeded && document?.document_file?.url) {
    window.location.href = document.document_file?.url;
  }

  return (
    <S.PageWrap>
      {readStatus.pending && (
        <Spinner message="Loading Document..." />
      )}

      {readStatus.failed && (
        <NotFound title="Something went wrong" />
      )}
    </S.PageWrap>
  );
};

export default RedirectToDocument;
